import type { CrmStageNamesReference, CrmStageNamesResponse } from '@aica/api-types';
import { getCrmVendor } from '@aica/core';

/**
 * The pipelines of the CRM install a row (a record, a funnel stage) belongs to,
 * from `GET /crm/stage-names`. Pipeline and stage ids are portal-local, so a
 * name is looked up in the list of the row's own install and nowhere else: a
 * row of another CRM — or of an install since replaced — keeps no name. `undefined`
 * — the list of that install is not there (the row has no install, the CRM did
 * not answer, it is paused).
 */
export function stageNamesOfInstallation(
  response: CrmStageNamesResponse | undefined,
  installationId: string | null | undefined
): CrmStageNamesReference['pipelines'] | undefined {
  if (!installationId) return undefined;
  return response?.references.find((list) => list.installationId === installationId)
    ?.pipelines;
}

/**
 * The name of the CRM an install is (`Bitrix24`, `Uspacy`) — what a screen with
 * the rows of several CRMs puts before a stage name so that two stages with the
 * same name read apart (as the «Продажи» card does). `undefined` — the install
 * has no list in the answer, so the CRM is not known.
 */
export function crmNameOfInstallation(
  response: CrmStageNamesResponse | undefined,
  installationId: string | null | undefined
): string | undefined {
  if (!installationId) return undefined;
  const provider = response?.references.find(
    (list) => list.installationId === installationId
  )?.provider;
  return provider ? (getCrmVendor(provider)?.displayName ?? provider) : undefined;
}
